import { statAssets } from '../../../constants/assets'
import type { PaymentSummary } from '../../../api/payments/paymentsApi'
import type { StatCard as StatCardModel } from '../../../types'
import { StatCard } from '../../overview/components/stats/StatCard'

type Props = {
  summary: PaymentSummary | null
  isLoading: boolean
}

const euro = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2,
})

export const PaymentStatRow = ({ summary, isLoading }: Props) => {
  const change = summary?.revenueChangePercent
  const placeholder = isLoading ? 'Loading�' : 'Unavailable'

  const stats: StatCardModel[] = [
    {
      id: 'total-revenue',
      label: 'Total Revenue',
      value: summary ? euro.format(summary.totalRevenue) : '�',
      icon: statAssets.revenue,
      chipSize: 35,
      glyphSize: 21,
      caption: summary
        ? change == null
          ? '\u00a0'
          : `${change > 0 ? '+' : ''}${change}% this month vs last month`
        : placeholder,
      showTrend: change != null && change > 0,
    },
    {
      id: 'todays-revenue',
      label: "Today's Revenue",
      value: summary ? euro.format(summary.todayRevenue) : '�',
      icon: 'clock',
      chipSize: 35,
      glyphSize: 24,
      caption: summary
        ? `${summary.todayPaymentsCount} Payments`
        : placeholder,
      showTrend: false,
    },
    {
      id: 'pending-payments',
      label: 'Pending Payments',
      value: summary ? euro.format(summary.pendingAmount) : '�',
      icon: 'clock',
      chipSize: 35,
      glyphSize: 24,
      caption: summary
        ? `${summary.pendingPaymentsCount} Pending Transactions`
        : placeholder,
      showTrend: false,
    },
  ]

  return (
    <section
      aria-label="Payment figures"
      aria-busy={isLoading}
      className="grid shrink-0 grid-cols-1 gap-[16px] sm:grid-cols-2 lg:grid-cols-3 xl:gap-[33px]"
    >
      {stats.map((stat) => (
        <StatCard key={stat.id} stat={stat} />
      ))}
    </section>
  )
}